import { useState } from "react";
import DashLayout from "../components/DashLayout";
import { Copy, Check, Box } from "lucide-react";

const SCRIPTS = {
    Windows: `iwr -useb https://get.synapselink.cloud/install.ps1 | iex`,
    npm: `npm install -g @synapselink/cli`,
};

const USAGE = `# 1. Authenticate (paste an API key from /app/keys)
synapselink login --key tf_live_xxxxxxxx

# 2. Forward localhost:3000 → persistent URL
synapselink 3000

# 3. Or pin a specific subdomain
synapselink 8080 --subdomain my-api

# 4. Inspect, replay, and password-protect from the dashboard.`;

export default function CliInstall() {
    const [tab, setTab] = useState("Windows");
    const [copied, setCopied] = useState("");

    const copy = (k, v) => {
        navigator.clipboard.writeText(v);
        setCopied(k);
        setTimeout(() => setCopied(""), 1200);
    };

    const tabs = [
        { name: "Windows", icon: Box },
        { name: "npm", icon: Box },
    ];

    return (
        <DashLayout title="INSTALL THE CLI" subtitle="dashboard / cli">
            <p className="text-sm text-[#A1A1AA] mb-6 max-w-2xl">Install via npm globally or use the Windows one-liner bootstrapper.</p>

            <div className="border border-[#27272A]">
                <div className="flex border-b border-[#27272A] bg-[#0A0A0A]" data-testid="cli-platform-tabs">
                    {tabs.map(({ name, icon: Icon }) => (
                        <button
                            key={name}
                            onClick={() => setTab(name)}
                            data-testid={`cli-tab-${name}`}
                            className={`px-5 py-3 flex items-center gap-2 text-xs uppercase tracking-widest border-r border-[#27272A] ${tab === name ? "bg-[#050505] text-[#00FF41] border-b-2 border-b-[#00FF41]" : "text-[#A1A1AA] hover:text-[#FAFAFA]"
                                }`}
                        >
                            <Icon className="w-4 h-4" /> {name}
                        </button>
                    ))}
                </div>
                <div className="p-6 bg-[#050505]">
                    <div className="flex items-center justify-between bg-[#0A0A0A] border border-[#18181B] px-4 py-3 font-mono text-sm" data-testid="cli-install-snippet">
                        <span className="text-[#00FF41] mr-3">$</span>
                        <span className="flex-1 text-[#FAFAFA] break-all">{SCRIPTS[tab]}</span>
                        <button onClick={() => copy("install", SCRIPTS[tab])} className="ml-3 text-[#52525B] hover:text-[#00FF41]" data-testid="copy-install-cmd">
                            {copied === "install" ? <Check className="w-4 h-4 text-[#00FF41]" /> : <Copy className="w-4 h-4" />}
                        </button>
                    </div>
                </div>
            </div>

            <div className="mt-8 grid lg:grid-cols-2 gap-0 border border-[#27272A]">
                <div className="p-6 border-r border-[#27272A]">
                    <div className="label-mono text-[#00FF41] mb-2">// USAGE</div>
                    <h3 className="font-display text-xl font-bold uppercase mb-4">Three lines to live.</h3>
                    <pre className="bg-[#050505] border border-[#18181B] p-4 font-mono text-xs text-[#FAFAFA] whitespace-pre-wrap overflow-x-auto" data-testid="cli-usage-snippet">
                        {USAGE}
                    </pre>
                </div>
                <div className="p-6">
                    <div className="label-mono text-[#FF9900] mb-2">// FLAGS</div>
                    <h3 className="font-display text-xl font-bold uppercase mb-4">Common options.</h3>
                    <table className="w-full text-xs font-mono">
                        <tbody>
                            {[
                                ["--subdomain <name>", "Pin to a specific subdomain"],
                                ["--key <tf_live_…>", "Override stored API key"],
                                ["--api <url>", "Override API base URL for this run"],
                            ].map(([f, d]) => (
                                <tr key={f} className="border-b border-[#18181B] last:border-b-0">
                                    <td className="py-2 pr-4 text-[#00FF41] whitespace-nowrap">{f}</td>
                                    <td className="py-2 text-[#A1A1AA]">{d}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </DashLayout>
    );
}
